import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { LayoutDashboard, Settings2, ListChecks, Users, Loader2, AlertTriangle } from "lucide-react";
import { PageHeader } from "@/components/common";
import { LoyaltyOverview } from "@/components/loyalty/LoyaltyOverview";
import { LoyaltySettings } from "@/components/loyalty/LoyaltySettings";
import { LoyaltyActivities } from "@/components/loyalty/LoyaltyActivities";
import { LoyaltyCustomers } from "@/components/loyalty/LoyaltyCustomers";
import { api, errMsg } from "@/lib/api";
import { cn } from "@/lib/utils";
import { toast } from "sonner";

const TABS = [
  { key: "visao", label: "Visão geral", icon: LayoutDashboard, comp: LoyaltyOverview, text: "Desempenho do programa no período escolhido." },
  { key: "config", label: "Configurações", icon: Settings2, comp: LoyaltySettings, text: "Regras de pontuação, benefícios e recompensas." },
  { key: "atividades", label: "Atividades", icon: ListChecks, comp: LoyaltyActivities, text: "Todos os pontos ganhos, resgatados e cancelados." },
  { key: "clientes", label: "Clientes", icon: Users, comp: LoyaltyCustomers, text: "Saldo e histórico de pontos de cada cliente." },
];

export default function Loyalty() {
  const [sp, setSp] = useSearchParams();
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.get("/loyalty/settings").then((r) => setCfg(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  const tab = TABS.find((t) => t.key === sp.get("aba")) || TABS[0];
  const Comp = tab.comp;
  return (
    <>
      <PageHeader eyebrow="Fidelidade" title={`Fidelidade · ${tab.label}`} subtitle={tab.text} />
      {cfg && !cfg.active && tab.key !== "config" && (
        <p className="flex flex-wrap items-center gap-2 rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-sm text-amber-600 dark:text-amber-400" data-testid="loyalty-off-banner">
          <AlertTriangle className="h-4 w-4" />O programa de fidelidade está desativado.
          <button onClick={() => setSp({ aba: "config" })} className="font-semibold underline" data-testid="loyalty-off-banner-link">Ativar em Configurações</button>
        </p>
      )}
      <div className="grid gap-6 lg:grid-cols-[210px_minmax(0,1fr)]">
        <nav className="flex gap-1 overflow-x-auto pb-1 lg:sticky lg:top-24 lg:flex-col lg:self-start" data-testid="loyalty-subnav">
          <p className="eyebrow hidden px-3 pb-2 lg:block">Fidelidade</p>
          {TABS.map(({ key, label, icon: Icon }) => (
            <button key={key} onClick={() => setSp({ aba: key })} data-testid={`loyalty-tab-${key}`}
              className={cn("flex shrink-0 items-center gap-2.5 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                tab.key === key ? "bg-primary/15 text-primary" : "text-muted-foreground hover:bg-accent hover:text-foreground")}>
              <Icon className="h-4 w-4" />{label}
            </button>
          ))}
        </nav>
        <div className="min-w-0">
          {cfg ? <Comp key={tab.key} cfg={cfg} setCfg={setCfg} /> : <div className="grid place-items-center py-20"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>}
        </div>
      </div>
    </>
  );
}
